export class ReferralsSearchFilter {
    PatientCode?: string;
    PatientName?: string;
    EncounterDate?: Date;
    RequestBy?: number;
    RequestDate: Date;
    Speciality? : number;
    Doctor?: number;
    Status?: number;
    PageIndex: number;
    PageSize: number;
    constructor() {
    }
}
